import EmailTableModel from "./EmailTableModel";

export default EmailTableModel;
